import React from 'react';
import { useTranslation } from "react-i18next";
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";



/**
 * @Description this page Array  Library's Array Action's configuration form
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @Returns     div element
 * @Author      Kerem Karadeniz
 */
export default function Add({ action, variables, setOpenVariable }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.ARRAY.';
    return (
        <div>
            <div className="form-element">
                {t(label + 'ARRAY-VARIABLE')}
                <TextInput action={action} inputName="set" variables={variables}
                    setOpenVariable={setOpenVariable} isRequired include={['array']} fieldType="array" displayName={t(label + 'ARRAY-VARIABLE')} />
            </div>
            <div className="form-element">
                {t(label + 'ITEM')}
                <TextInput action={action} inputName="item" variables={variables}
                    setOpenVariable={setOpenVariable} isRequired multiline={4} />
                <small><em>e.g. "test" or 5</em></small>
            </div>
        </div>
    )
}
